import { PageEntityInterface } from '../types/base-entity-interface'
import {
  PageContentEntities,
  PageContentInterface,
} from '../types/page-interface'
import { isEntityWithChildIds } from './is-entity-with-child-ids'

export const getAllDescendants = (
  entities: PageContentInterface['entities'],
  entity: PageEntityInterface,
): PageContentEntities => {
  const result: PageContentEntities = {}

  if (!isEntityWithChildIds(entity)) {
    return result
  }

  // Get valid child IDs
  const validChildIds = entity.childIds.filter(childId => !!entities[childId])

  // Process each child
  for (const childId of validChildIds) {
    // Add the child entity to the result
    result[childId] = entities[childId]

    // Get descendants of the child and merge them into the result
    const childDescendants = getAllDescendants(entities, entities[childId])
    Object.assign(result, childDescendants)
  }

  return result
}
